<template>
  <div>
    <template v-for="(item) in members">
      <div :key="item.title_id" style="padding-top: 48px"  class="vhtml" v-html="item[`title_${lang}`]"></div>
      <div :key="item.description_id" class="vhtml" v-html="item[`content_${lang}`]"></div>
    </template>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  created() {

  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang,
      members: state => {
        return [
          ...state.ServiceMenu.member_tcdc.filter(val => val.member_topic_type_id === 1).map(member => ({
            title_id: member.id,
            description_id : parseInt(member.id) + 20,
            title_th: `<h class="bold sub-header1 text-tcdc-green">` + member.title_th + `</h> <br/><br/>`,
            title_en: `<h class="bold sub-header1 text-tcdc-green">` + member.title_en + `</h> <br/><br/>`,
            content_th: `<span>` + member.detail_th + `</span>`,
            content_en: `<span>` + member.detail_en + `</span>`,
          }))
        ]
      }
    }),
  },
};
</script>

<style></style>
